import { Typography, useTheme } from "@mui/material";
import { format, getDay } from "date-fns";
import type { FC } from "react";
import { WEEKDAY_LABEL_FORMAT } from "web_myplann/Shared/Components/FlatRow/datePanelHelpers";
import { useDateFnsLocale } from "web_myplann/Shared/Hooks/useDateFnsLocale";

type Props = {
	days: Date[];
};

export const FlatRowDateWeekdayList: FC<Props> = ({ days }) => {
	const { datePanel } = useTheme();
	const locale = useDateFnsLocale();

	return (
		<>
			{days.map((day) => (
				<Typography
					key={getDay(day)}
					variant="hint"
					fontSize={datePanel.weekdayLabel.fontSize}
					display="flex"
					alignItems="center"
					justifyContent="center"
					height={datePanel.weekdayLabel.height}
				>
					{format(day, WEEKDAY_LABEL_FORMAT, { locale })}
				</Typography>
			))}
		</>
	);
};
